import * as React from "react";

const GreenTriangle2 = (props: any) => (
  <svg
    width={30}
    height={25}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m0 0 30 5.999L17.125 25 0 0Z"
      fill="#67EBB2"
    />
  </svg>
);

export default GreenTriangle2;
